// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_21-2";
export var blackBorderOnHover = "_21-7";
export var cell = "_21-6";
export var cellContainer = "_21-3";
export var checked = "_21-8";
export var disabled = "_21-5";
export var featuredIconCellContainer = "_21-9";
export var featuredIconTextContainer = "_21-b";
export var featuredIconWrapper = "_21-a";
export var noBorder = "_21-c";
export var orangeSelectedRow = "_4w-3";
export var overflowableText = "_21-0";
export var overflowableTextContainer = "_21-1";
export var row = "_1u-0";
export var rowCheckboxCell = "_21-4";
export var selectableTable = "_4w-2";